import React, { useState, useEffect } from 'react';
import { UserAuth } from '../../../context/AuthContext';
import { useTheme } from '../../../context/ThemeContext';
import { AlertCircle, CheckCircle2, ArrowRight, Package, Zap, Crown, Loader } from 'lucide-react';
import './NewComponent.css';

const PlansPop = () => {
  const { token } = UserAuth();
  const { isDarkMode, themeClass } = useTheme();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const LoadingState = () => (
    <div className="loading-banner">
      <Loader className="loading-icon animate-spin" />
      <p>Cargando información de suscripción...</p>
    </div>
  );
  
  const plans = [
    {
      id: 'test',
      name: 'Plan Gratuito',
      price: 'Q0.00',
      colorClass: 'plan-blue',
      icon: <Package className="plan-icon" />,
      description: 'Ideal para conocer nuestro servicios',
      features: [
        'Acceso a búsquedas básicas',
        'limite de 5 preguntas diarias'
      ]
    },
    {
      id: 'experto',
      name: 'Plan Experto',
      price: 'Q29.99',
      colorClass: 'plan-purple',
      icon: <Zap className="plan-icon" />,
      description: 'Características mejoradas para profesionales',
      features: [
        'Preguntas Ilimitadas',
        'Generación de Diagramas',
        'Guardar Preguntas',
        'Analisis Intermedio',
        'Contexto limitado de Artículos',
        'Acceso a nuevos Features',
      ],
      popular: true
    },
    {
      id: 'sabio',
      name: 'Plan Sabio',
      price: 'Q79.99',
      colorClass: 'plan-green',
      icon: <Crown className="plan-icon" />,
      description: 'Máximas capacidades para expertos',
      features: [
        'Preguntas Ilimitadas',
        'Generación de Diagramas',
        'Guardar Preguntas',
        'Analisis Profundo',
        'Ingresa textos más largos',
        'Contexto de Artículos Extenso',
        'Hasta 6 veces más Extenso que el nivel Experto',
        'Acceso a Publicaciones del diario oficial',
        'Acceso a nuevas Funcionalidades y actualizaciones',
        'Soporte 24/7'
      ]
    }
  ];

  const initiateCheckout = async (planId) => {
    setLoading(true);
    setSelectedPlan(planId);
    setError(null);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL_PASARELA}/api/recurrente/nuevocliente?desired_plan=${planId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success && data.checkout_url) {
          window.location.href = data.checkout_url;
        } else {
          setError('Respuesta de checkout inválida');
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'No se pudo crear el checkout');
      }
    } catch (error) {
      setError('Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`subscription-container ${themeClass}`}>
      <div className={`plans-section ${themeClass}`}>
        <div className={`section-header ${themeClass}`}>
          <h2>Nuestros Planes</h2>
          <p>Elige el plan que mejor se adapte a tus necesidades</p>
        </div>

        <div className="plans-grid">
          {plans.map((plan) => (
            <div 
              key={plan.id} 
              className={`plan-card ${plan.colorClass} ${plan.popular ? 'popular' : ''} ${themeClass}`}
            >
              {plan.popular && <div className="popular-tag">Más Popular</div>}
              <div className={`plan-header ${themeClass}`}>
                {plan.icon}
                <h3>{plan.name}</h3>
                <p className={`plan-price ${themeClass}`}>
                  {plan.price}
                  <span className={`plan-price-month ${themeClass}`}>/mes</span>
                </p>
                <p className={`plan-description ${themeClass}`}>{plan.description}</p>
                <div className={`linePlan ${themeClass}`} />
              </div>
              
              <ul className={`feature-list ${themeClass}`}>
                {plan.features.map((feature, index) => (
                  <li key={index}>
                    <CheckCircle2 className="feature-icon" />
                    {feature}
                  </li>
                ))}
              </ul>

              {plan.id !== 'test' && (
                <button
                  onClick={() => initiateCheckout(plan.id)}
                  disabled={loading && selectedPlan === plan.id}
                  className="select-plan-button"
                >
                  {loading && selectedPlan === plan.id ? (
                    'Procesando...'
                  ) : (
                    <>
                      Seleccionar Plan
                      <ArrowRight className="button-icon" />
                    </>
                  )}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlansPop;